import Link from "next/link";
import { WorkspaceSubscriptionProblem } from "lib/types/subscriptions/WorkspaceSubscriptionProblem";
import WarningSvg from "components/icons/24/notifications/warning-triangle.svg";
import HoverTooltip from "components/elements/Tooltips/HoverTooltip";

type SubscriptionProblemBannerProps = {
  problem: WorkspaceSubscriptionProblem | null;
  workspaceId: number;
};

export default function SubscriptionProblemBanner({
  problem,
  workspaceId,
}: SubscriptionProblemBannerProps): React.JSX.Element | null {
  if (!problem) return null;

  return (
    <HoverTooltip placement="left" customTooltipContent="More info">
      <Link
        className="flex items-center rounded-md bg-red-400 px-4 py-1"
        href={{
          pathname: "/workspaces/[workspaceId]/settings",
          query: { workspaceId, tab: "subscription" },
        }}
      >
        <WarningSvg className="w-6 text-white" />
        <span className="pl-2 text-white">{problem.bannerMessage}</span>
      </Link>
    </HoverTooltip>
  );
}
